import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const archiveYears = {
  cuzkArchive2023: '2023,2022',
  cuzkArchive2021: '2021,2020',
  cuzkArchive2019: '2019,2018',
  cuzkArchive2017: '2017,2016',
  cuzkArchive2015: '2015,2014',
  cuzkArchive2013: '2013,2012',
  cuzkArchive2011: '2011,2010,2009',
};

type ArchiveYears = keyof typeof archiveYears;
type Years = typeof archiveYears[ArchiveYears];

export const archiveCuzkLayer = (year: Years = archiveYears.cuzkArchive2019) =>
  new TileLayer({
    id: `archive-cuzk-layer-${year}`,
    getTileData: async ({ bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const url = `https://geoportal.cuzk.cz/WMS_ORTOFOTO_ARCHIV/service.svc/get?format=image/png&bbox=${south},${west},${north},${east}&crs=EPSG%3A4326&request=GetMap&width=256&height=256&service=WMS&transparent=TRUE&version=1.3.0&layers=${year}&styles=`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
